import { useAppSelector } from "../redux"

export const useValidAspects = () => {
  const imagesByAspect = useAppSelector(state => state.product.product_no_design.data?.product_details?.default?.images)

  return Object.keys((imagesByAspect || [])[0] || {})
}